import axiosInstance from '../api/axiosInstance';

export interface TrainingCategory {
  id: string;
  name: string;
  key: string;
  description: string | null;
  companyId: string | null;
  isPublic: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TrainingCompany {
  id: string;
  name: string;
  description: string;
  avatar: string;
  email: string;
  imported_countries: string[];
  services: string[];
  city: string;
  country: string;
  website: string;
  businessType: string;
}

export interface TrainingItemResponse {
  id: string;
  content: string;
  categoryId: string;
  title: string;
  companyId: string;
  createdAt: string;
  updatedAt: string;
  category: TrainingCategory;
  company: TrainingCompany;
}

export interface TrainingInformationResponse {
  data: TrainingItemResponse[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface GetTrainingInformationParams {
  page?: number;
  limit?: number;
  categoryId?: string;
  search?: string;
}

export interface CreateTrainingInformationRequest {
  content: string;
  categoryId: string;
  title: string;
}

export interface UpdateTrainingInformationRequest {
  content: string;
  categoryId: string;
  title: string;
}

export interface CreateTrainingCategoryRequest {
  name: string;
  description?: string;
}

export const aiTrainingAPI = {
  getTrainingInformation: async (
    params: GetTrainingInformationParams = {}
  ): Promise<TrainingInformationResponse> => {
    const queryParams: Record<string, string | number> = {
      page: params.page || 1,
      limit: params.limit || 10,
    };

    if (params.categoryId) {
      queryParams.categoryId = params.categoryId;
    }

    if (params.search && params.search.trim()) {
      queryParams.search = params.search.trim();
    }

    const response = await axiosInstance.get<TrainingInformationResponse>(
      '/training-information',
      {
        params: queryParams,
      }
    );
    return response.data;
  },
  getTrainingCategories: async (): Promise<TrainingCategory[]> => {
    const response = await axiosInstance.get<TrainingCategory[]>(
      '/training-categories'
    );
    return response.data;
  },
  createTrainingCategory: async (
    data: CreateTrainingCategoryRequest
  ): Promise<TrainingCategory> => {
    const response = await axiosInstance.post<TrainingCategory>(
      '/training-categories',
      data
    );
    return response.data;
  },
  createTrainingInformation: async (
    data: CreateTrainingInformationRequest
  ): Promise<TrainingItemResponse> => {
    const response = await axiosInstance.post<TrainingItemResponse>(
      '/training-information',
      data
    );
    return response.data;
  },
  updateTrainingInformation: async (
    id: string,
    data: UpdateTrainingInformationRequest
  ): Promise<TrainingItemResponse> => {
    const response = await axiosInstance.patch<TrainingItemResponse>(
      `/training-information/${id}`,
      data
    );
    return response.data;
  },
  deleteTrainingInformation: async (id: string): Promise<void> => {
    await axiosInstance.delete(`/training-information/${id}`);
  },
};
